<app-modal [modalConfig]="modalConfig">
    <div class="icon-content" *ngIf="body.isError">
        <fa-icon class="error-icon" [icon]="faIcon"></fa-icon>
    </div>
    <div class="message">
        <p *ngIf="body.message">
            {{ body.message }}
        </p>
    </div>
    <div class="options">
        <button *ngIf="body.closeTitle" type="button" class="close" (click)="close(false)">
            {{body.closeTitle}}
        </button>

        <button *ngIf="body.confirmTitle" type="button" class="confirm" (click)="close(true)">
            {{body.confirmTitle}}
        </button>
    </div>
</app-modal>